import { Add, KeyRounded } from '@mui/icons-material';
import { LoadingButton, TabContext, TabList, TabPanel } from '@mui/lab';
import { Alert, Avatar, Button, CircularProgress, Stack, Tab, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setSearchValue, setSelectedItem } from 'app/actions/token';
import { IconButton, InputSearch, Scrollbar } from 'app/components';
import { TokenDialog, TokenForm, TokenList } from 'app/pages/Token';
import TokenTransportGroupList from 'app/pages/Token/TokenTransportGroupList';
import { itemsTokenSelector, searchValueTokenSelector, selectedItemTokenSelector, transportGroupsTokenIdSelector, } from 'app/selectors/token';
import { useAsyncAction } from 'app/services';
import { tokenLoad, tokenTransportGroupLoad, tokenUpdate } from 'app/store/token';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const Token = () => {
    const formRef = useRef(null);
    const dispatch = useDispatch();
    const items = useSelector(itemsTokenSelector);
    const selectedItem = useSelector(selectedItemTokenSelector);
    const searchValue = useSelector(searchValueTokenSelector);
    const transportGroupsTokenId = useSelector(transportGroupsTokenIdSelector);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [tab, setTab] = useState('info');
    const [transportGroupSearchValue, setTransportGroupSearchValue] = useState('');
    const selectedIdRef = useRef(null);
    const { asyncAction: fetchData, isLoading: isFetchLoading } = useAsyncAction(tokenLoad);
    const { asyncAction: fetchGroupData, isLoading: isFetchGroupLoading, isError: isFetchGroupError, } = useAsyncAction(tokenTransportGroupLoad, [selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id]);
    const { asyncAction: updateSubmit, isLoading: isUpdateLoading, isSuccessful: isUpdateSuccessful, isError: isUpdateError, } = useAsyncAction(tokenUpdate, [selectedItem]);
    const handleDialogOpen = () => {
        setDialogOpen(true);
    };
    const handleDialogClose = () => {
        setDialogOpen(false);
    };
    const handleFormClick = () => {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleFormSubmit();
    };
    const handleFormSubmit = (params) => {
        if (selectedItem) {
            updateSubmit(selectedItem.id, params);
        }
    };
    const handleSearchChange = (value) => dispatch(setSearchValue(value));
    const handleTabChange = (_event, value) => {
        setTab(value);
    };
    const groupsReady = !!selectedItem && transportGroupsTokenId === selectedItem.id;
    useEffect(() => {
        if (!selectedItem) {
            selectedIdRef.current = null;
            return;
        }
        if (selectedIdRef.current !== selectedItem.id) {
            selectedIdRef.current = selectedItem.id;
            setTransportGroupSearchValue('');
            fetchGroupData(selectedItem.id);
        }
    }, [selectedItem]);
    useEffect(() => {
        fetchData();
        return () => {
            dispatch(setSelectedItem(null));
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                width: '500px',
                height: '100%',
                zIndex: '1010',
                overflow: 'hidden',
                bgcolor: 'background.paper',
                borderRight: '1px solid',
                borderColor: theme.palette.divider,
            }) },
            !isFetchLoading && items.length !== 0 && (React.createElement(React.Fragment, null,
                React.createElement(Stack, { direction: 'row', alignItems: 'center', sx: (theme) => ({
                        padding: theme.spacing(2),
                    }) },
                    React.createElement(InputSearch, { placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0442\u043E\u043A\u0435\u043D\u0430', value: searchValue, onChange: handleSearchChange }),
                    React.createElement(IconButton, { onClick: handleDialogOpen, endIcon: React.createElement(Add, null) }),
                    React.createElement(TokenDialog, { open: dialogOpen, onClose: handleDialogClose })),
                React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                        flex: '1 1 auto',
                        overflow: 'hidden',
                    } },
                    React.createElement(TokenList, null)))),
            !isFetchLoading && items.length === 0 && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                    width: '100%',
                    height: '100%',
                } },
                React.createElement(Typography, { align: 'center', variant: 'body1', component: 'div' }, "\u0417\u0434\u0435\u0441\u044C \u043F\u043E\u043A\u0430 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435\u0442"),
                React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'div' }, "\u0412 \u044D\u0442\u043E\u043C \u0441\u043F\u0438\u0441\u043A\u0435 \u0431\u0443\u0434\u0443\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u0442\u043E\u043A\u0435\u043D\u044B"))),
            isFetchLoading && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                    width: '100%',
                    height: '100%',
                } },
                React.createElement(CircularProgress, { size: 24 })))),
        React.createElement(Stack, { direction: 'column', sx: {
                height: '100%',
                flex: '1 1 auto',
                minWidth: 0,
                '.simplebar-content': {
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                },
            } },
            selectedItem && (React.createElement(Scrollbar, null,
                React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                        maxWidth: '540px',
                        margin: '0 auto',
                        width: '100%',
                        height: '100%',
                        padding: theme.spacing(4, 2, 2),
                    }) },
                    React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                            marginBottom: theme.spacing(3),
                            '.MuiAvatar-root': {
                                width: '56px',
                                height: '56px',
                                bgcolor: theme.palette.primary.main,
                            },
                            '.MuiTypography-root:first-of-type': {
                                marginTop: theme.spacing(1),
                            },
                        }) },
                        React.createElement(Avatar, null,
                            React.createElement(KeyRounded, { fontSize: 'large' })),
                        React.createElement(Typography, { variant: 'body1' }, selectedItem.name)),
                    React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                            width: '100%',
                            height: tab === 'group' ? '100%' : 'auto',
                            minHeight: 0,
                            position: 'relative',
                            border: '1px solid',
                            borderRadius: theme.shape.borderRadius,
                            borderColor: theme.palette.divider,
                            bgcolor: 'background.paper',
                            '.MuiTabPanel-root': {
                                width: '100%',
                                padding: theme.spacing(2),
                            },
                            form: {
                                width: '100%',
                            },
                        }) },
                        React.createElement(TabContext, { value: tab },
                            React.createElement(TabList, { onChange: handleTabChange, TabIndicatorProps: {
                                    children: React.createElement("span", null),
                                }, sx: (theme) => ({
                                    width: '100%',
                                    minHeight: '44px',
                                    borderBottom: '1px solid',
                                    borderColor: theme.palette.divider,
                                    '.MuiTab-root': {
                                        fontSize: '12px',
                                        minHeight: '44px',
                                        padding: theme.spacing(2),
                                        '&.Mui-selected': {
                                            color: 'inherit',
                                        },
                                    },
                                    '& .MuiTabs-indicator': {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        backgroundColor: 'transparent',
                                    },
                                    '& .MuiTabs-indicator span': {
                                        width: 'calc(100% - ' + theme.spacing(4) + ')',
                                        bgcolor: theme.palette.primary.main,
                                        borderRadius: theme.shape.borderRadius,
                                    },
                                }) },
                                React.createElement(Tab, { value: 'info', label: '\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F', disableRipple: true }),
                                React.createElement(Tab, { value: 'group', label: '\u0413\u0440\u0443\u043F\u043F\u044B \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430', disableRipple: true })),
                            React.createElement(TabPanel, { value: 'info' },
                                React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                                        width: '100%',
                                        paddingBottom: theme.spacing(1),
                                        '.MuiTypography-h6': {
                                            fontSize: '1rem',
                                        },
                                        '.MuiTypography-caption': {
                                            color: theme.palette.text.secondary,
                                        },
                                    }) },
                                    React.createElement(Typography, { variant: 'h6' }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"),
                                    React.createElement(Typography, { variant: 'caption' }, "\u041E\u0441\u043D\u043E\u0432\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0442\u043E\u043A\u0435\u043D\u0430")),
                                React.createElement(TokenForm, { ref: formRef, defaultValues: selectedItem, onSubmit: handleFormSubmit }),
                                React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                        width: '100%',
                                        '.MuiAlert-root': {
                                            width: '100%',
                                            marginTop: theme.spacing(2),
                                            borderRadius: theme.shape.borderRadius,
                                        },
                                    }) },
                                    !isUpdateLoading && isUpdateError && (React.createElement(Alert, { severity: 'error' }, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438 \u0434\u0430\u043D\u043D\u044B\u0445. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.")),
                                    !isUpdateLoading && isUpdateSuccessful && React.createElement(Alert, { severity: 'success' }, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B.")),
                                React.createElement(Stack, { direction: 'row', gap: 2, justifyContent: 'flex-end', sx: (theme) => ({
                                        width: '100%',
                                        paddingTop: theme.spacing(3),
                                    }) },
                                    React.createElement(LoadingButton, { variant: 'contained', loading: isUpdateLoading, onClick: handleFormClick, disableElevation: true }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F"))),
                            React.createElement(TabPanel, { value: 'group', style: {
                                    height: '100%',
                                    minHeight: 360,
                                    padding: 0,
                                } },
                                (isFetchGroupLoading || (!groupsReady && !isFetchGroupError)) && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                                        width: '100%',
                                        height: '100%',
                                        padding: theme.spacing(2),
                                    }) },
                                    React.createElement(CircularProgress, { size: 24 }))),
                                !isFetchGroupLoading && isFetchGroupError && (React.createElement(Stack, { sx: (theme) => ({ padding: theme.spacing(2) }) },
                                    React.createElement(Alert, { severity: 'error', action: React.createElement(Button, { color: 'inherit', size: 'small', onClick: () => fetchGroupData(selectedItem.id) }, "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C") }, "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0433\u0440\u0443\u043F\u043F\u044B \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430."))),
                                groupsReady && !isFetchGroupLoading && (React.createElement(Stack, { direction: 'column', sx: { height: '100%', minHeight: 0 } },
                                    React.createElement(Stack, { direction: 'row', alignItems: 'center', sx: (theme) => ({
                                            padding: theme.spacing(2),
                                        }) },
                                        React.createElement(InputSearch, { placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0433\u0440\u0443\u043F\u043F\u044B \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430', value: transportGroupSearchValue, onChange: setTransportGroupSearchValue })),
                                    React.createElement(Stack, { direction: 'column', sx: {
                                            flex: '1 1 auto',
                                            minHeight: 0,
                                        } },
                                        React.createElement(TokenTransportGroupList, { tokenId: selectedItem.id, searchValue: transportGroupSearchValue })))))))))),
            !selectedItem && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                    height: '100%',
                    padding: theme.spacing(0, 2),
                    '.MuiTypography-root': {
                        borderRadius: '20px',
                        marginTop: '24px',
                        padding: theme.spacing(0.5, 2),
                        bgcolor: alpha(theme.palette.grey.main, 0.12),
                    },
                }) },
                React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'label' }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u043E\u043A\u0435\u043D \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430"))))));
};
export default Token;
